import { MARKER_COLOR } from '../constants'

function getClusterSpiderfyStyle() {
  const points = {
    id: 'spiderfied-points',
    type: 'circle',
    source: 'spiderfied-points',
    paint: {
      'circle-color': MARKER_COLOR,
      'circle-radius': 8,
      'circle-stroke-color': '#ffffff', // White outline
      'circle-stroke-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        4, // Hover state - thicker stroke
        2 // Normal state
      ]
    }
  }
  const lines = {
    id: 'spiderfied-lines',
    type: 'line',
    source: 'spiderfied-lines',
    paint: { 'line-color': '#ffffff', 'line-width': 1.5 }
  }

  return { points, lines }
}

export { getClusterSpiderfyStyle }
